import { PATHS } from '../../config/consts';
import { DEVICE_TYPE } from '../../config/devices';
import {
  getDashboardElectronicLockService,
  getSitesServiceMobileVideoLicenceModel,
} from '../../modules/sites/selectors';

export const getDeviceLicenceModel = (state, deviceType) =>
  deviceType === DEVICE_TYPE.DORMAKABA_ELECTRONIC_LOCK
    ? getDashboardElectronicLockService(state).licenceModel
    : getSitesServiceMobileVideoLicenceModel(state);

export const getPurchaseSubscriptionPath = (device) =>
  (device?.type === DEVICE_TYPE.DORMAKABA_ELECTRONIC_LOCK
    ? PATHS.SUBSCRIPTION
    : PATHS.SUBSCRIPTION_MOBILE_VIDEO
  )
    .replace(':companyId', device?.site?.company?.id)
    .replace(':siteId', device?.site?.id);

export const isActive = (services) => !!services && !!Object.keys(services).length;

// Dormakaba locks can be listed before their services are provisioned, they still need to be actionable
export const hasDeviceActions = (device) =>
  isActive(device?.services) || device?.type === DEVICE_TYPE.DORMAKABA_ELECTRONIC_LOCK;
